/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Search extends Component {
  state = { searchValue: '' };

  componentDidMount() {
    const { initFocus = false } = this.props;
    initFocus && this.searchInput.current.focus();
  }

  searchInput = React.createRef();

  onSearchValueChange = (event) => {
    const searchValue = event.target.value;
    const { onChange } = this.props;

    this.setState(() => ({ searchValue }));
    onChange && onChange(searchValue);
  };

  doSearch = () => {
    const { onSearch } = this.props;
    const { searchValue } = this.state;

    onSearch && onSearch(searchValue);
  };

  clearSearch = () => {
    this.setState(() => ({ searchValue: '' }));
    this.searchInput.current.focus();

    const { onSearch, onChange } = this.props;
    onSearch && onSearch('');
    onChange && onChange('');
  };

  onKeyPress = (event) => {
    const enterKeyPressed = event.key === 'Enter';
    enterKeyPressed && this.doSearch();
  };

  render() {
    const { placeholder = '', id = '' } = this.props;
    const { searchValue } = this.state;

    return (
      <div className="search-component-common" id={id}>
        <input
          ref={this.searchInput}
          className="search-component-input"
          value={searchValue}
          placeholder={placeholder}
          onChange={this.onSearchValueChange}
          onKeyPress={this.onKeyPress}
        />
        {searchValue.length > 0 ? (
          <div className="search-component-clear" onClick={this.clearSearch} />
        ) : (
          <div className="search-component-icon" />
        )}
      </div>
    );
  }
}

Search.propTypes = {
  placeholder: PropTypes.string,
  onSearch: PropTypes.func,
  onChange: PropTypes.func,
  id: PropTypes.string,
  initFocus: PropTypes.bool
};
